import angular from 'angular';

import cvtDashboardModule from './cvt-dashboard/cvt-dashboard';

const Components = angular.module('control-room.internal.components.cvt.components', [cvtDashboardModule.name]);

export default Components;
